import React from "react";

import { getFieldError } from "../../getFieldError";
import { PracticeField } from "../PracticeField/PracticeField";
import styles from "./PracticeTextField.module.css";

/**
 * One Formik-bound text field: label, input and its error message.
 */
export const PracticeTextField = ({
  formik,
  name,
  label,
  placeholder,
  isRequired = false,
  span = "half",
  maxLength,
  ariaLabel,
}) => {
  const errorMessage = getFieldError(formik, name);

  return (
    <PracticeField
      label={label}
      htmlFor={name}
      isRequired={isRequired}
      errorMessage={errorMessage}
      span={span}
    >
      <input
        id={name}
        name={name}
        type="text"
        autoComplete="off"
        className={`${styles.input} ${errorMessage ? styles.inputError : ""}`}
        placeholder={placeholder}
        maxLength={maxLength}
        aria-label={ariaLabel}
        aria-required={isRequired ? "true" : undefined}
        onBlur={formik.handleBlur}
        onChange={formik.handleChange}
        value={formik.values[name]}
      />
    </PracticeField>
  );
};
